import { useEffect, useState } from "react";
import { Loader2, CheckSquare, Check } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { PageHeader, PriorityBadge } from "@/components/common/ui";
import { cn } from "@/lib/utils";

export default function Tasks() {
  const [tasks, setTasks] = useState(null);
  const load = () => api.get("/tasks").then((r) => setTasks(r.data)).catch(() => setTasks([]));
  useEffect(() => { load(); }, []);

  const complete = async (id) => { try { await api.post(`/tasks/${id}/complete`); toast.success("Task completed"); load(); } catch (e) {} };

  if (!tasks) return <div className="flex h-64 items-center justify-center text-muted-foreground"><Loader2 className="animate-spin" /></div>;

  return (
    <div>
      <PageHeader overline="Workspace" title="Tasks"
        description="Your prioritized work queue across every CAREIQ module." />
      <div className="overflow-hidden rounded-xl border bg-card shadow-sm divide-y">
        {tasks.map((t) => (
          <div key={t.id} data-testid={`task-row-${t.id}`} className={cn("flex items-center gap-4 px-4 py-3", t.status === "completed" && "opacity-50")}>
            <PriorityBadge level={t.priority} />
            <div className="min-w-0 flex-1">
              <div className={cn("font-medium", t.status === "completed" && "line-through")}>{t.title}</div>
              <div className="text-xs text-muted-foreground">{t.module} · due {t.due_date}</div>
            </div>
            {t.status !== "completed" ? (
              <button data-testid={`complete-${t.id}`} onClick={() => complete(t.id)} className="flex items-center gap-1 rounded-md border px-3 py-1.5 text-xs font-medium hover:border-[#12B76A] hover:text-[#12B76A]"><Check size={13} /> Complete</button>
            ) : <span className="text-xs font-medium text-[#12B76A]">Done</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
